import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  // 公开路由：官网首页
  { path: '/', name: 'Home', component: () => import('../views/OfficialWebsiteView.vue'), meta: { title: '空调服务中心', public: true } },
  // 公开路由：后台登录
  { path: '/login', name: 'Login', component: () => import('../views/LoginView.vue'), meta: { title: '后台登录', public: true } },
  // 受保护路由：后台管理
  {
    path: '/admin',
    name: 'Index',
    component: () => import('../views/IndexView.vue'),
    redirect: '/admin/dashboard',
    children: [
      { path: '/admin/dashboard', name: 'Dashboard', component: () => import('../views/DashboardView.vue'), meta: { title: '派单工作台' } },
      { path: '/admin/order/all', name: 'OrderAll', component: () => import('../views/order/OrderAllView.vue'), meta: { title: '工单管理' } },
      { path: '/admin/stats', name: 'Stats', component: () => import('../views/stats/StatsView.vue'), meta: { title: '统计图表' } },
      { path: '/admin/customer/list', name: 'CustomerList', component: () => import('../views/customer/CustomerListView.vue'), meta: { title: '客户管理' } },
      { path: '/admin/repairman/list', name: 'RepairmanList', component: () => import('../views/repairman/RepairmanListView.vue'), meta: { title: '维修员管理' } },
      { path: '/admin/job/list', name: 'JobList', component: () => import('../views/job/JobListView.vue'), meta: { title: '职位管理' } },
      { path: '/admin/article/list', name: 'ArticleList', component: () => import('../views/article/ArticleListView.vue'), meta: { title: '文章管理' } },
      { path: '/admin/sysUser/list', name: 'SysUserList', component: () => import('../views/system/SysUserListView.vue'), meta: { title: '系统用户' } },
      { path: '/admin/log/list', name: 'OperationLog', component: () => import('../views/log/OperationLogView.vue'), meta: { title: '操作日志' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 全局路由守卫：未登录访问后台路由时跳转登录页
router.beforeEach((to, from, next) => {
  // 公开路由直接放行
  if (to.meta.public || to.name === 'Home' || to.name === 'Login') {
    next()
    return
  }
  // 已登录放行
  const token = store.state.token
  if (token) {
    next()
  } else {
    // 未登录访问后台 → 跳转登录页，并记录来源地址用于登录后回跳
    next({ name: 'Login', query: { redirect: to.fullPath } })
  }
})

export default router
